import CheckoutError from './CheckoutError.js'

export default class PurchaseDetailsCheckoutError extends CheckoutError {}
